import { LDFlagsService } from '../ld-flags.service';

export class SearchLDFlags {
  /***
   *  Team: Platform Services
   *  Created Date: 5/06/2023 https://github.com/degreed/Degreed/pull/35258
   *  Planned Cleanup: 1/6/2024 [PD-91488]
   *  Visibility:
   *    - Org 1
   *    - Pre-Release: NL Catalog Search
   *
   *  Enables POC for natural language results when searching for content
   */
  public get naturalLanguageCatalogSearch(): boolean {
    return this.ldFlagsService.getFlag(
      'natural-language-catalog-search',
      false
    );
  }

  /***
   *  Team: Search & Discovery
   *  Created Date: 07/2022 https://degreedjira.atlassian.net/browse/PD-77294
   *  Planned Cleanup: unknown https://degreedjira.atlassian.net/browse/PD-77300
   *  Visibility:
   *    - handful of orgs that don't want this functionality
   *
   *  Enables handling of typos in global search
   */
  public get showTypoSuggestions(): boolean {
    return this.ldFlagsService.getFlag('search-typo-handler', false);
  }

  /***
   *  Team: Search & Discovery
   *  Created Date: 02/2023 https://degreedjira.atlassian.net/browse/PD-79060
   *  Planned Cleanup: unknown https://degreedjira.atlassian.net/browse/PD-83680
   *  Visibility:
   *    - Pre-Release: Prioritize Endorsed Content in Search
   *
   *  Enables prioritization of endorsed content in global search
   */
  public get showPrioritizedEndorsedContent(): boolean {
    return this.ldFlagsService.getFlag(
      'prioritize-endorsed-content-search',
      false
    );
  }

  /***
   *  Team: Learner Experience
   *  Created Date: 02/2023 https://degreedjira.atlassian.net/browse/PD-91737
   *  Planned Cleanup: unknown
   *  Visibility:
   *    - enabled for all?
   *
   *  Enables price range filter in marketplace search
   */
  public get showMarketplacePriceRangeFilters(): boolean {
    return this.ldFlagsService.getFlag('marketplace-price-filter', false);
  }

  constructor(private ldFlagsService: LDFlagsService) {}
}
